export const NoticeSvg = ({
  color,
  width = 18,
  height = 18,
  style = {},
}: any) => (
  <svg
    style={{ ...style }}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>编组 3</title>
    <g id="紫白" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.402669271" strokeLinecap="round">
        <g id="黑金-酒店首页" transform="translate(-29.000000, -295.000000)" stroke="var(--primary-text-color, #222222)" strokeWidth="1.5">
            <g id="编组-3" transform="translate(30.000000, 296.000000)">
                <line x1="0.443555302" y1="5.33333333" x2="0.443555302" y2="10.6666667" id="路径-5"></line>
                <path d="M4.07331452,3.71658526 L9.48114533,0.796523531 C9.96710994,0.534117644 10.5737841,0.715347792 10.83619,1.20131239 C10.9150063,1.34727693 10.9562732,1.5105558 10.9562732,1.67644028 L10.9562732,14.3235597 C10.9562732,14.8758445 10.508558,15.3235597 9.95627322,15.3235597 C9.79038874,15.3235597 9.62710987,15.2822928 9.48114533,15.2034765 L4.07331452,12.2834147 C3.74997723,12.1088226 3.54844241,11.7709615 3.54844241,11.403498 L3.54844241,4.59650201 C3.54844241,4.2290385 3.74997723,3.89117742 4.07331452,3.71658526 Z" id="矩形"></path>
                <path d="M14.52125,10.4 C15.4038253,9.91907396 15.9971838,9.02321055 15.9971838,7.9974601 C15.9971838,6.97531026 15.4079836,6.08213721 14.5305334,5.6" id="路径"></path>
            </g>
        </g>
    </g>
  </svg>
)
